export default __webpack_public_path__ + "static/media/clock.d7fb04f2.svg";